<div>
  <cc-top-bar [title]="('ONBOARDING.HEADER' | translate)"></cc-top-bar>

  <div class="responsive-container">
    <router-outlet></router-outlet>
  </div>
</div>
